import TokenLoginInfo from './TokenLoginInfo';

export default TokenLoginInfo;
